import { createTranslator } from '@typeform/js-translations';
import translations from "../translations";
export default function getTranslateFunctionForTests(locale) {
  return createTranslator(translations, locale);
}